<vi-page [sidenavs]="true" [footer]="true">
  <vi-content body>
    <vi-panel main [title]="'Buttons with text ellipsis & tooltip'">
      <div class="content ellipsis-example" content>
        <ng-container *ngFor="let button of buttons">
          <ng-container [ngSwitch]="button.type">
            <span
              >{{ button.name }}
              <span
                [matTooltipShowDelay]="matTooltipShowDelay"
                [matTooltipHideDelay]="matTooltipHideDelay"
                matTooltip="{{ button.translation | translate }}"
              >
                <button
                  *ngSwitchCase="'mat-button'"
                  mat-button
                  color="primary"
                  [disabled]="button.disabled"
                >
                  {{ button.translation | translate }}
                </button>
                <button
                  *ngSwitchCase="'mat-raised-button'"
                  mat-raised-button
                  color="primary"
                  [disabled]="button.disabled"
                >
                  {{ button.translation | translate }}
                </button>
                <button
                  *ngSwitchCase="'mat-stroked-button'"
                  mat-stroked-button
                  color="primary"
                  [disabled]="button.disabled"
                >
                  {{ button.translation | translate }}
                </button>
              </span>
            </span>
          </ng-container>
        </ng-container>
      </div>
    </vi-panel>

    <vi-panel main [title]="'Buttons with text wrapped in lines'">
      <div class="content text-wrap-example" content>
        <ng-container *ngFor="let button of buttons">
          <ng-container [ngSwitch]="button.type">
            <span
              >{{ button.name }}
              <button
                *ngSwitchCase="'mat-button'"
                mat-button
                color="primary"
                [disabled]="button.disabled"
              >
                {{ button.translation | translate }}
              </button>
              <button
                *ngSwitchCase="'mat-raised-button'"
                mat-raised-button
                color="primary"
                [disabled]="button.disabled"
              >
                {{ button.translation | translate }}
              </button>
              <button
                *ngSwitchCase="'mat-stroked-button'"
                mat-stroked-button
                color="primary"
                [disabled]="button.disabled"
              >
                {{ button.translation | translate }}
              </button>
            </span>
          </ng-container>
        </ng-container>
      </div>
    </vi-panel>

    <vi-panel main [title]="'Buttons with text run through the button - marquee effect'">
      <div class="content marquee-example" content>
        <ng-container *ngFor="let button of buttons">
          <ng-container [ngSwitch]="button.type">
            <span
              >{{ button.name }}
              <button
                class="marquee"
                *ngSwitchCase="'mat-button'"
                mat-button
                color="primary"
                [disabled]="button.disabled"
              >
                <span>{{ button.translation | translate }}</span>
              </button>
              <button
                class="marquee"
                *ngSwitchCase="'mat-raised-button'"
                mat-raised-button
                color="primary"
                [disabled]="button.disabled"
              >
                <span>{{ button.translation | translate }}</span>
              </button>
              <button
                class="marquee"
                *ngSwitchCase="'mat-stroked-button'"
                mat-stroked-button
                color="primary"
                [disabled]="button.disabled"
              >
                <span>{{ button.translation | translate }}</span>
              </button>
            </span>
          </ng-container>
        </ng-container>
      </div>
    </vi-panel>

    <vi-panel main [title]="'Buttons with text run through the button - bounce effect'">
      <div class="content marquee-example" content>
        <ng-container *ngFor="let button of buttons">
          <ng-container [ngSwitch]="button.type">
            <span
              >{{ button.name }}
              <button
                class="bounce"
                *ngSwitchCase="'mat-button'"
                mat-button
                color="primary"
                [disabled]="button.disabled"
              >
                <span>{{ button.translation | translate }}</span>
              </button>
              <button
                class="bounce"
                *ngSwitchCase="'mat-raised-button'"
                mat-raised-button
                color="primary"
                [disabled]="button.disabled"
              >
                <span>{{ button.translation | translate }}</span>
              </button>
              <button
                class="bounce"
                *ngSwitchCase="'mat-stroked-button'"
                mat-stroked-button
                color="primary"
                [disabled]="button.disabled"
              >
                <span>{{ button.translation | translate }}</span>
              </button>
            </span>
          </ng-container>
        </ng-container>
      </div>
    </vi-panel>
  </vi-content>
</vi-page>
